import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../../lib/i18n";

export const NatureBand = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <section ref={ref} className="relative h-[70svh] min-h-[420px] overflow-hidden" data-testid="nature-band">
      <motion.img style={{ y }} src="/img/split.jpg" alt="" className="absolute inset-0 h-[124%] w-full -translate-y-[12%] object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#073B4C]/75 via-[#073B4C]/20 to-transparent" />
      <div className="relative mx-auto flex h-full max-w-7xl items-end px-5 pb-14 md:px-10 md:pb-20">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl font-display text-4xl leading-[1.05] text-[#FBF7EF] sm:text-5xl lg:text-6xl"
          data-testid="nature-band-quote"
        >
          {t.band}
        </motion.p>
      </div>
    </section>
  );
};
